/* istanbul ignore file */
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

export const phoneFormats = [{
  name: 'US',
  mask: '(999) 999-9999',
  countryCode: '1',
  get validate() {
    const self = this;

    return (input, allowEmpty = false) => {
      let isvalid = false;

      if (input) {
        // stripping off country code, 1 or +1
        const preprocessed = input.replace(/^(\+)?1/, '');
        isvalid = (preprocessed.match(/\d/g) || []).length === 10;
      }
      if (allowEmpty) {
        if (!input) {
          return true;
        }
        return isvalid || (new RegExp(`^${self.countryCode}[-|(|)|#|\\s]*`).test(input));
      }
      return isvalid;
    };
  },
}, {
  name: 'General',
  mask: '',
  countryCode: '',
  get validate() {
    return (input, allowEmpty = false) => {
      if (!input || !input.trim()) {
        return allowEmpty;
      }

      const { PhoneNumberRegExp } = Constants;
      const re = new RegExp(PhoneNumberRegExp);
      const validRegExp = re.test(input);

      // At least 1 countryCalling code + 7 number digits and smaller than 17 number digits
      const digitLength = (input.match(/\d/g) || []).length;
      const validDigit = digitLength > 7 && digitLength < 18;

      return validRegExp && validDigit;
    };
  },
}];
